<template lang="pug">
van-nav-bar(:title='modelFileName' fixed :left-arrow="hasLeft" @click-left='onClickLeft' )
  template(#right)
    span.jylabel(v-show='has2D' @click='openDwg') 2D
    van-icon(name='setting-o' color='#464646' size='20' @click="openOther('set')")
</template>

<script>
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
import { mapState } from "vuex";
export default {
  data () {
    return {
      groupPics: []
    };
  },
  computed: {
    ...mapState({
      loginUserId: state => state.user.userId
    }),
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    hasLeft() {
      return !this.$route.query.i;
    },
    modelReady() {
      return mongeApp.model.modelReady;
    },
    isLoginFree() {
      return this.$route.query.isLoginFree || "";
    },
    modelFileName() {
      if (this.modelInfoData.fileObj) {
        return this.modelInfoData.fileObj.map(e => e.folderName).join();
      }
      return this.modelInfoData.fileName || "未命名";
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    has2D() {
      return this.groupPics.length > 0;
    },
    modelPageFileName() {
      return mongeApp.model.modelPageFileName;
    },
    modelMapList() {
      return mongeApp.model.modelMapList;
    },
    annotationData() { // 模型图纸的批注信息
      return mongeApp.model.annotationData;
    },
    // 状态字典
    statusList() {
      return mongeApp.dicList?.statusList || [];
    },
    userId() {
      return this.$route.query.userId || this.loginUserId;
    }
  },
  watch: {
    modelReady(val) {
      if (val) {
        this.loadMapList();
      }
    },
    modelPageFileName(val) {
      if (val) {
        this.openNowDwg();
      }
    }
  },
  created () {
    if (this.modelReady) this.loadMapList();
  },
  methods: {
    async loadMapList() {
      this.groupPics = [];
      if (this.mlibEnabled) {
        const models = await mongeApiMlib.getModels();
        let modelAttrList = [];
        models.forEach(element => {
          const bimexDetailList = element.url?.bimexDetailList;
          const array = bimexDetailList.map(i => {
            return { ...i, modelId: element.id };
          });
          modelAttrList = [...modelAttrList, ...array];
        });
        this.groupPics = modelAttrList.filter(ele => ele.label === "2D-IMG");
        mongeMutations.setModelMapList(this.groupPics);
      } else {
        if (this.modelInfoData.fileObj) { // 多文件
          await this.multiMaps();
        } else if (this.modelInfoData.fileId) { // 单文件
          await this.singleMap();
        }
      }
      this.questionId = this.$route.query.questionId;
      this.flowInstanceId = this.$route.query.flowInstanceId || '';
      this.shareId = this.$route.query.i || '';
      if (this.questionId) { // 定位
        await mongeCommon.getDicList(this.modelInfoData.prjId, this.flowInstanceId);
        await mongeCommon.getNotationData(this.questionId, this.userId, "model", this.flowInstanceId, this.shareId);
      }
    },
    async multiMaps() {
      for (const iterator of this.modelInfoData.fileObj) {
        await this.getDwgList(iterator.folderID, iterator.rvtVersion);
      }
    },
    singleMap() {
      const fileId = this.modelInfoData.fileId;
      const rvtVersion = this.modelInfoData.rvtVersion || "";
      this.getDwgList(fileId, rvtVersion);
    },
    async getDwgList(fileId, rvtVersion) {
      const { data } = await mongeService.queryDwgList(fileId, rvtVersion);
      const list = mongeApiMlib.assembleMapUrl(data, fileId, rvtVersion);
      this.groupPics = [...this.groupPics, ...list];
      mongeMutations.setModelMapList(this.groupPics);
    },
    // 头部按钮返回
    onClickLeft() {
      const data = { source: "back" };
      let { isH5 } = this.$route.query || {};
      mongeApiMlib.rebackLastPage(this.isLoginFree || isH5, data);
    },
    openOther() {
      this.$emit("openOther", "set");
    },
    async openDwg() {
      if (this.mlibEnabled) {
        const { drawName } = this.groupPics[0];
        mongeMutations.setHasDwg(true);
        mongeMutations.setModelPageFileName(decodeURIComponent(drawName));
      } else {
        const { picName } = this.groupPics[0];
        mongeMutations.setHasDwg(true);
        mongeMutations.setModelPageFileName(decodeURIComponent(picName));
      }
    },
    async openNowDwg() {
      if (this.mlibEnabled) {
        const item = this.modelMapList.find(e => decodeURIComponent(e.drawName) === this.modelPageFileName) ;
        const { drawName, modelId } = item;
        const models = await mongeApiMlib.getModels();
        mongeMutations.setModelPageFileName(decodeURIComponent(drawName));
        const list = models.find(e => e.id === modelId).url?.bimexDetailList;
        const url = list.filter(item => item.drawName === drawName && item.label === "2D");
        const bimexDetailList = [];
        url.forEach(e => {
          if (!e.drawName) return;
          const bimexItemFile = {
            originFileName: e.lightFileName,
            url: e.downloadUrl,
            fileId: e.fileId
          };
          bimexDetailList.push(bimexItemFile);
        });
        const spaceWithDetailItems = {
          bimexId: drawName,
          bimexName: drawName,
          convertFilePathId: drawName,
          bimexDetailList
        };
        const params = { url: spaceWithDetailItems, id: 'dwgbox', longforLoading: true, modelId };
        await mongeApiMlib.load2D(params);
      } else {
        const item = this.modelMapList.find(e => decodeURIComponent(e.picName) === this.modelPageFileName);
        const { picsurl, modelFileId, rvtVersion } = item;
        const params = {
          url: picsurl,
          id: 'dwgbox',
          longforLoading: true,
          modelFileId,
          rvtVersion
        };
        await mongeApiMlib.load2D(params);
      }
      await this.$nextTick();
      mongeApiMlib.resize();
      if (this.annotationData) {
        mongeCommon.modelmapFitToH5(this.annotationData, this.statusList);
        mongeMutations.setModelMapData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.van-nav-bar__content {
  height: 88upx;
}
.jylabel{
  margin-right: 8px;
  color: var(--theme-color);
  font-size: 16px;
  font-weight: 800;
}
</style>
